"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = function _default(obj) {
  (0, _forEach2["default"])(obj, function (type, key) {
    (0, _forEach2["default"])(type, function (subtype, key1) {
      var names = subtype.map(function (item) {
        return item.name;
      });
      names.forEach(function (name, index) {
        if (names.indexOf(name, index + 1) !== -1) {
          throw new Error("There is a duplicate template name \"".concat(name, "\" (").concat(key, "/").concat(key1, ")"));
        }
      });
    });
  });
};
exports["default"] = _default;